// useScrollOnPathChange.ts
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export function useScrollOnPathChange(targetRef: React.RefObject<HTMLElement>, opts?: { offset?: number; smooth?: boolean; delayMs?: number }) {
  const { pathname, search, hash } = useLocation();
  const offset = opts?.offset ?? 0;
  const smooth = opts?.smooth ?? true;
  const delayMs = opts?.delayMs ?? 0;

  useLayoutEffect(() => {
    const el = targetRef.current;
    if (!el) return;

    const doScroll = () => {
      if (offset > 0) {
        const rect = el.getBoundingClientRect();
        const y = window.scrollY + rect.top - offset;
        window.scrollTo({ top: y, behavior: smooth ? "smooth" : "auto" });
      } else {
        el.scrollIntoView({ behavior: smooth ? "smooth" : "auto", block: "start" });
      }
    };

    if (delayMs > 0) {
      const id = setTimeout(doScroll, delayMs);
      return () => clearTimeout(id);
    }

    // two rafs helps when content layout shifts (e.g., images/fonts/forms)
    requestAnimationFrame(() => requestAnimationFrame(doScroll));
  }, [pathname, search, hash, offset, smooth, delayMs, targetRef]);
}
